
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { Suspense } from "react";
import LoadingSpinner from "./components/base/LoadingSpinner";
import ScrollToTop from "./components/base/ScrollToTop";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <Suspense fallback={<LoadingSpinner />}>
          <AppRoutes />
        </Suspense>
        <ScrollToTop />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
